import merge from 'lodash/merge'
import { createSelector } from '@reduxjs/toolkit'

const entitiesSliceName = 'entities'

const REPLACE_ENTITY_FIELDS = 'entities/replaceEntityFields'

// Targeted single-entity write that REPLACES the given fields instead of
// going through the deep merge below (lodash merge combines arrays by index,
// so a shorter fresh array can never remove stale cached items).
export function replaceEntityFields(entityType, id, fields) {
  return { type: REPLACE_ENTITY_FIELDS, payload: { entityType, id, fields } }
}

function entitiesReducer(s, action) {
  const state = s || {}
  const { payload, type } = action
  if (type === 'session/logout') return {}
  if (type === REPLACE_ENTITY_FIELDS) {
    const { entityType, id, fields } = payload
    if (!state[entityType] || !state[entityType][id]) return state
    return {
      ...state,
      [entityType]: {
        ...state[entityType],
        [id]: { ...state[entityType][id], ...fields },
      },
    }
  }
  if (!payload || !payload.entities) return state
  return merge({}, state, payload.entities)
}

const selectState = state => state[entitiesSliceName]

export const getEntities = createSelector(selectState, entities => entities)

export const getCycles = createSelector(
  getEntities,
  entities => entities.cycles,
)

const entities = {
  reducer: entitiesReducer,
  name: entitiesSliceName,
}

export default entities
